const RECENT_GOOGLE_SHEETS_PREFIX = "recentGoogleSheets";
const MAX_RECENT_GOOGLE_SHEETS = 10;


function getStorageKey(employeeId) {
  return `${RECENT_GOOGLE_SHEETS_PREFIX}:${employeeId || "anonymous"}`;
}


export function getRecentGoogleSheets(employeeId) {
  try {
    const raw = localStorage.getItem(getStorageKey(employeeId));
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}


export function markRecentGoogleSheet(employeeId, file) {
  if (!file?.id) {
    return [];
  }

  const current = getRecentGoogleSheets(employeeId).filter(
    (item) => item?.id && item.id !== file.id
  );

  const next = [
    {
      id: file.id,
      name: file.name || "Untitled spreadsheet",
      ownerName: file.ownerName || "",
      ownerEmail: file.ownerEmail || "",
      webViewLink: file.webViewLink || "",
      lastUsedAt: new Date().toISOString(),
    },
    ...current,
  ].slice(0, MAX_RECENT_GOOGLE_SHEETS);

  try {
    localStorage.setItem(getStorageKey(employeeId), JSON.stringify(next));
  } catch {
    // Ignore storage failures and keep the feature non-blocking.
  }

  return next;
}
